/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { createTeamRoleRequestSchema } from './createTeamRoleRequestSchema';

export const createBulkTeamRolesRequestSchema = z.object({
  get roles() {
    return z.array(createTeamRoleRequestSchema).min(1);
  },
});
